export default [
  {
    path: '/controle-vencimento',
    name: 'controlevencimento',
    component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoControleVencimento/Geral/ParametrizacaoControleVencimento.vue'),
    meta: {
      resource: 'controlevencimento',
      action: 'create',
      pageTitle: 'Parametrizações de Controle de Vencimento',
      breadcrumb: [],
    },
  },
]
